import React, { useState, useEffect } from 'react';
import feedbackService from './services/feedbackService';
import crmService from './services/crmService';

const TestSaveFeatures = () => {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const addTestResult = (test, result, details = '') => {
    setTestResults(prev => [...prev, { test, result, details, timestamp: new Date().toISOString() }]);
  };

  const runTests = async () => {
    setLoading(true);
    setTestResults([]);

    // Test 1: Check if services are imported correctly
    try {
      addTestResult('Service Imports', 'PASS', 'feedbackService and crmService imported successfully');
    } catch (error) {
      addTestResult('Service Imports', 'FAIL', error.message);
    }

    // Test 2: Check feedbackService methods
    try {
      if (typeof feedbackService.getFeedbacksByLead === 'function' &&
          typeof feedbackService.submitFeedback === 'function' &&
          typeof feedbackService.getLeadHistory === 'function') {
        addTestResult('FeedbackService Methods', 'PASS', 'All required methods exist');
      } else {
        addTestResult('FeedbackService Methods', 'FAIL', 'Missing required methods');
      }
    } catch (error) {
      addTestResult('FeedbackService Methods', 'FAIL', error.message);
    }

    // Test 3: Check crmService methods
    try {
      if (typeof crmService.updateLead === 'function') {
        addTestResult('CRMService Methods', 'PASS', 'updateLead method exists');
      } else {
        addTestResult('CRMService Methods', 'FAIL', 'updateLead method missing');
      }
    } catch (error) {
      addTestResult('CRMService Methods', 'FAIL', error.message);
    }

    // Test 4: Check localStorage for auth token
    try {
      const authToken = localStorage.getItem('authToken');
      if (authToken) {
        addTestResult('Authentication', 'PASS', `Auth token exists (${authToken.substring(0, 20)}...)`);
      } else {
        addTestResult('Authentication', 'WARNING', 'No auth token found in localStorage');
      }
    } catch (error) {
      addTestResult('Authentication', 'FAIL', error.message);
    }

    // Test 5: Test API connectivity
    try {
      console.log('Testing API connectivity...');
      const testResponse = await fetch('/api/properties', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      if (testResponse.ok) {
        addTestResult('API Connectivity', 'PASS', `API responded with status ${testResponse.status}`);
      } else {
        addTestResult('API Connectivity', 'FAIL', `API responded with status ${testResponse.status}`);
      }
    } catch (error) {
      addTestResult('API Connectivity', 'FAIL', error.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    runTests();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>🧪 Save Features Test Dashboard</h1>
      <p>Testing the save functionality and API integration...</p>

      <button
        onClick={runTests}
        disabled={loading}
        style={{
          padding: '10px 20px',
          backgroundColor: loading ? '#ccc' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: loading ? 'not-allowed' : 'pointer',
          marginBottom: '20px'
        }}
      >
        {loading ? 'Running Tests...' : 'Run Tests Again'}
      </button>

      <div>
        <h2>Test Results:</h2>
        {testResults.length === 0 && !loading && (
          <p>No test results yet. Click "Run Tests Again" to start.</p>
        )}

        {testResults.map((result, index) => (
          <div
            key={index}
            style={{
              padding: '10px',
              margin: '5px 0',
              border: '1px solid #ddd',
              borderRadius: '5px',
              backgroundColor: result.result === 'PASS' ? '#d4edda' :
                             result.result === 'WARNING' ? '#fff3cd' : '#f8d7da'
            }}
          >
            <div style={{ fontWeight: 'bold' }}>
              {result.result === 'PASS' ? '✅' : result.result === 'WARNING' ? '⚠️' : '❌'}
              {result.test}: {result.result}
            </div>
            {result.details && (
              <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                {result.details}
              </div>
            )}
            <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>
              {new Date(result.timestamp).toLocaleTimeString()}
            </div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: '30px', fontSize: '14px', color: '#666' }}>
        <h3>Next Steps:</h3>
        <ul>
          <li>If all tests pass, the save features should work correctly</li>
          <li>If API tests fail, check your backend server</li>
          <li>If auth tests fail, try logging in at <a href="/BuilderLogin">/BuilderLogin</a></li>
          <li>Check browser console (F12) for additional error details</li>
        </ul>
      </div>
    </div>
  );
};

export default TestSaveFeatures;